import { IIntegracaoFiltro, IIntegracaoHttp, IIntegracaoOperacao, IIntegracaoPagina } from "../interfaces/IIntegracaoLog";
import api from "./Api";
import Swal from "sweetalert2";

const BASE_URL = process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3';

// O interceptor do Api já troca o erro por { message } com a mensagem do backend.
function erro(error: any) {
  Swal.fire({ text: error.message, timer: 5000, icon: 'error', showConfirmButton: false });
}

const vazia = <T,>(): IIntegracaoPagina<T> => ({ itens: [], total: 0, pagina: 1, tamanhoPagina: 50 });

function params(filtro: object) {
  return Object.fromEntries(Object.entries(filtro).filter(([, v]) => v !== undefined && v !== ''));
}

// DEVN3-636: logs de integração da API pública (Administrador e Master). clienteId só vale para Master.
class IntegracaoLogService {

  async operacoes(filtro: IIntegracaoFiltro & { situacao?: string }): Promise<IIntegracaoPagina<IIntegracaoOperacao>> {
    try {
      const { data } = await api.get<IIntegracaoPagina<IIntegracaoOperacao>>('integracao-log/operacoes', { baseURL: BASE_URL, params: params(filtro) });
      return data;
    } catch (error: any) {
      erro(error);
      return vazia();
    }
  }

  async operacao(id: number, clienteId?: number): Promise<IIntegracaoOperacao | null> {
    try {
      const { data } = await api.get<IIntegracaoOperacao>(`integracao-log/operacoes/${id}`, { baseURL: BASE_URL, params: params({ clienteId }) });
      return data;
    } catch (error: any) {
      erro(error);
      return null;
    }
  }

  async http(filtro: IIntegracaoFiltro & { faixaStatus?: number }): Promise<IIntegracaoPagina<IIntegracaoHttp>> {
    try {
      const { data } = await api.get<IIntegracaoPagina<IIntegracaoHttp>>('integracao-log/http', { baseURL: BASE_URL, params: params(filtro) });
      return data;
    } catch (error: any) {
      erro(error);
      return vazia();
    }
  }
}

export default new IntegracaoLogService();
